const el = document.getElementsByClassName('details'),
    className = 'is-toggle',
    clickerFn = function(e) {

        e.preventDefault();

        const elId = document.getElementById(this.id); 
        const detailsInfo = document.querySelector('#info-' + this.id);

        if (elId) {
            
            //console.log('Click just happened ' + elId.className);
            if (elId.classList) {
                elId.classList.toggle(className);
            
            } else {

                const classes = elId.className.split(' ');
                const existingIndex = classes.indexOf(className);

            if (existingIndex >= 0)

                classes.splice(existingIndex, 1);

            else
                classes.push(className);

                elId.className = classes.join(' ');
            }
        }

        if (detailsInfo) {
            
            if (detailsInfo.classList) {
                detailsInfo.classList.toggle(className);
            
            } else {

                const classesInfo = detailsInfo.className.split(' ');
                const existingIndexInfo = classesInfo.indexOf(className);

            if (existingIndexInfo >= 0)

                classes.splice(existingIndexInfo, 1);

            else
            classesInfo.push(className);

                detailsInfo.className = classesInfo.join(' ');
            }
        }

    }
    
    for (var i=0; i < el.length; i++) {

        el.item(i).onclick = clickerFn;

    }


// WEBPACK FOOTER //
// ./resources/assets/js/shopping-cart-details.js